export default __webpack_public_path__ + "static/media/10-min.78367235.jpg";